import { Modal } from "@mui/material"
import CloseIcon from "@mui/icons-material/Close";
import { useEffect, useState } from "react";
import { loader } from "../../Func_genericas/loader";
import { IPlanoERPSchema, IReceita } from "../../Interfaces/financeiro/financeiro";
import AddIcon from "@mui/icons-material/Add";
import { Modaladdreceitas } from "./add_receitas";

interface I_aux {
    list: IReceita[],
    flag_open_modal: boolean,
    set_flag_open_modal: React.Dispatch<React.SetStateAction<boolean>>,
    setMessage: React.Dispatch<React.SetStateAction<string>>,
    setOpenSnackSuccess: React.Dispatch<React.SetStateAction<boolean>>,
    setOpenSnackError: React.Dispatch<React.SetStateAction<boolean>>,
    set_list: React.Dispatch<React.SetStateAction<IReceita[]>>,
    obj_financeiro: IPlanoERPSchema | undefined,
    set_obj_new_financeiro: React.Dispatch<React.SetStateAction<IPlanoERPSchema | undefined>>,

}

export const Modalverlistareceitas: React.FC<I_aux> = ({
    list,
    flag_open_modal,
    set_flag_open_modal,
    setMessage,
    setOpenSnackSuccess,
    setOpenSnackError,
    set_list,
    obj_financeiro,
    set_obj_new_financeiro,

}) => {

    const [isLoading, setIsLoading] = useState<boolean>(false);


    const [flag_open_modal_ver_mais, set_flag_open_modal_ver_mais] = useState<boolean>(false);
    const [flag_open_modal_edit, set_flag_open_modal_edit] = useState<boolean>(false);
    const [flag_open_modal_add, set_flag_open_modal_add] = useState<boolean>(false);
    const [flag_open_modal_aux, set_flag_open_modal_aux] = useState<boolean>(false);
    const [obj_new, set_obj_new] = useState<IReceita>();
    const [hover, setHover] = useState<{ flag: boolean; id: number | null }>({ flag: false, id: null });

    useEffect(() => {
        (async () => {
            set_list(obj_financeiro?.receitas ?? [])
        })();
    }, []);



    return (<Modal
        style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
        }}
        open={flag_open_modal}
    >
        <div className="flex flex-col bg-white w-[70%] max-h-[80%] rounded-xl overflow-hidden">
            <div className="flex items-center justify-between w-full p-4 border-b border-gray-100">
                <h2 className="text-xl font-semibold text-gray-800 m-0 pl-2">
                    Detalhes do Plano ERP
                </h2>
                <button
                    type="button"
                    onClick={() => {
                        set_flag_open_modal(false)
                        set_flag_open_modal_ver_mais(false)
                    }}
                    className="p-1 text-gray-400 hover:text-gray-600 transition-colors border-0 outline-none cursor-pointer !bg-transparent hover:!bg-transparent"
                >
                    <CloseIcon sx={{ fontSize: 24 }} />
                </button>
            </div>


            {
                flag_open_modal_aux === true &&
                <Modaladdreceitas
                    list={list}
                    flag_open_modal={flag_open_modal_aux}
                    set_flag_open_modal={set_flag_open_modal_aux}
                    setMessage={setMessage}
                    setOpenSnackSuccess={setOpenSnackSuccess}
                    setOpenSnackError={setOpenSnackError}
                    set_list={set_list}
                    flag_open_modal_ver_mais={flag_open_modal_ver_mais}
                    set_flag_open_modal_ver_mais={set_flag_open_modal_ver_mais}
                    flag_open_modal_edit={flag_open_modal_edit}
                    set_flag_open_modal_edit={set_flag_open_modal_edit}
                    flag_open_modal_add={flag_open_modal_add}
                    set_flag_open_modal_add={set_flag_open_modal_add}
                    set_obj_new={set_obj_new}
                    obj_new={obj_new}
                    obj_financeiro={obj_financeiro}
                    set_obj_new_financeiro={set_obj_new_financeiro}

                />
            }

            {
                isLoading === true ?
                    loader() :
                    <>
                        <div className="flex flex-col w-full flex-1 overflow-auto">
                            <div className="flex flex-col w-full flex-1 overflow-auto">
                                <div className="w-full p-5 flex justify-start">
                                    <button
                                        type="button"
                                        onClick={() => {
                                            set_flag_open_modal_aux(true);
                                            set_flag_open_modal_edit(true);
                                            set_flag_open_modal_add(true);
                                            set_obj_new(undefined);
                                        }}
                                        className="inline-flex items-center gap-2 px-4 py-2.5 rounded-xl font-medium text-sm text-white bg-[#c94f1e] hover:bg-[#b84720] transition-colors border-0 outline-none cursor-pointer"
                                    >
                                        <AddIcon sx={{ fontSize: 18 }} />
                                        Adicionar Registo de Receitas
                                    </button>
                                </div>

                                {list.length > 0 ? (
                                    <div className="w-full px-5 pb-5">
                                        <div className="text-sm font-semibold text-gray-500 mb-3">
                                            Registos de Receitas
                                        </div>

                                        <div className="flex flex-wrap gap-4">
                                            {list.map((el, index) => {
                                                const isSelected = obj_new?.id_receita === el.id_receita;
                                                const isHovered = hover.flag && hover.id === el.id_receita;

                                                return (
                                                    <div
                                                        key={index}
                                                        className={`
                                                            flex flex-col items-center justify-center w-[180px] min-w-[180px] w-full max-w-[250px] p-4 rounded-xl cursor-pointer
                                                            transition-all duration-200
                                                            ${isSelected ? 'ring-2 ring-[#c94f1e] bg-[#f2d1c2]/30' : 'bg-gray-50/80'}
                                                            ${isHovered ? 'shadow-md' : 'shadow-sm'}
                                                          `}
                                                        onMouseEnter={() => setHover({ flag: true, id: el.id_receita })}
                                                        onMouseLeave={() => setHover({ flag: false, id: el.id_receita })}

                                                        onClick={() => {
                                                            set_flag_open_modal_aux(true)
                                                            set_obj_new(el)
                                                            set_flag_open_modal_ver_mais(true)
                                                            set_flag_open_modal_edit(false)
                                                            set_flag_open_modal_add(false)
                                                        }}  >
                                                        <div className="space-y-2 text-sm">
                                                            <div className="grid grid-cols-[72px_1fr] gap-x-3 items-center">
                                                                <span className="text-gray-500">Tipo</span>
                                                                <span className="text-gray-800 font-medium truncate text-right">
                                                                    {el.tipo || '-'}
                                                                </span>
                                                            </div>

                                                            <div className="grid grid-cols-[72px_1fr] gap-x-3 items-center">
                                                                <span className="text-gray-500">Descrição</span>
                                                                <span className="text-gray-800 font-medium truncate text-right">
                                                                    {el.descricao || '-'}
                                                                </span>
                                                            </div>

                                                            <div className="grid grid-cols-[72px_1fr] gap-x-3 items-center">
                                                                <span className="text-gray-500">Cliente</span>
                                                                <span className="text-gray-800 font-medium truncate text-right">
                                                                    {el.cliente || '-'}
                                                                </span>
                                                            </div>

                                                            <div className="grid grid-cols-[72px_1fr] gap-x-3 items-center">
                                                                <span className="text-gray-500">Estado</span>
                                                                <span className="text-gray-800 font-medium truncate text-right">
                                                                    {el.estado || '-'}
                                                                </span>
                                                            </div>

                                                            <div
                                                                className={`mt-2 w-full h-1 rounded-full ${isSelected ? 'bg-[#c94f1e]' : 'bg-gray-200'}`}
                                                            />
                                                        </div>


                                                    </div>
                                                )
                                            })}
                                        </div>
                                    </div>
                                ) : (
                                    <div className="w-full px-5 pb-5">
                                        <div className="w-full rounded-xl border border-dashed border-gray-300 bg-gray-50 px-4 py-8 text-center text-sm text-gray-400">
                                            Não existem registos de receitas.
                                        </div>
                                    </div>
                                )}
                            </div>
                        </div>
                    </>
            }

        </div>



    </Modal>)

}
